<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active" aria-current="page">Revisión de solicitudes</li>
            </ol>
        </nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 mb-4">
                    <vx-card>
                        <div class="row">
                            <div class="col-md-9">
                                <h1 class="bold big-title m-0">Revisión de <span>solicitudes</span>.</h1>
                            </div>
                        </div>
                    </vx-card>
                </div>
            </div>
        </div>
        <projects-list :filters="filters" variant="preapproved" @itemClick="showApproveModal"/>
        <approve-list-modal ref="approveListModalComp"/>
    </div>
</template>

<script>
    import ProjectsList from "../../../components/ProjectRequestsList";
    let ApproveListModal = require('../../../components/admin/approveListModal').default;

    export default {
        name: "ProjectsPreapproved",
        components: {
            ProjectsList,
            ApproveListModal
        },
        data: () => ({
            filters: {
                'projects.status': [1,2,3],
                resolution_date: null
            }
        }),
        methods:{
            showApproveModal(e) {
                this.$refs["approveListModalComp"].show(e.id)
            }
        }
    }
</script>

<style scoped>

</style>